import {
    GET_ALL_AWARD_REQUEST ,
    GET_ALL_AWARD_SUCCESS ,
    GET_ALL_AWARD_FAILURE ,

    GET_AWARD_RECIPIENTS_LIST_REQUEST,
    GET_AWARD_RECIPIENTS_LIST_SUCCESS,
    GET_AWARD_RECIPIENTS_LIST_FAILURE,
  
} from "./actionTypes";

const initialState = {
  ISLOADING: false, // Fixed typo (was "ISlOADING")
  ALL_AWARD_LIST: [], 
  ALL_AWARD_RECIPIENT_LIST: [],
  ISFAILURE: false,
};

export  function ALL_AWARD_LISTreducer(state = initialState, { type, payload }) {
  switch (type) {
    case GET_ALL_AWARD_REQUEST:
      return { ...state, ISLOADING: true }; // Fixed typo
    case GET_ALL_AWARD_SUCCESS:
      return {
        ...state,
        ALL_AWARD_LIST: payload, // Updated key to match news-related data
        ISLOADING: false,
      };
    case GET_ALL_AWARD_FAILURE:
      return { ...state, ISFAILURE: true, ISLOADING: false };

      case GET_AWARD_RECIPIENTS_LIST_REQUEST:
        return { ...state, isLoading: true, isFailure: false };
  
      case GET_AWARD_RECIPIENTS_LIST_SUCCESS:
        return {
          ...state,
          ALL_AWARD_RECIPIENT_LIST: payload,
          isLoading: false,
        };
  
      case GET_AWARD_RECIPIENTS_LIST_FAILURE:
        return {
          ...state,
          isFailure: true,
          isLoading: false,
        };  
    default:
      return state;
  }
}
